import { render, staticRenderFns } from "./DocForm.vue?vue&type=template&id=07df5ece&"
import script from "./DocForm.vue?vue&type=script&lang=js&"
export * from "./DocForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports